import { useParams } from "react-router-dom";
import { useImmer } from "use-immer";
import { getRetailProductsApi } from "../api/ProductApi";
import { errorMessage } from "../../../utils";
import React from "react";

export const useRetailProductList = () => {
  const { id } = useParams();

  const [state, setState] = useImmer({
    loading: true,
    retailProducts: [],
    filteredProducts: [],
    filters: {
      status: "",
    },
    appliedFilters: {
      status: "",
    },
    hasChanges: false,
  });

  const getRetailProducts = async (productId) => {
    try {
      const response = await getRetailProductsApi(productId);
      const { success, message, data } = response;
      if (success) {
        setState((draft) => {
          draft.retailProducts = data;
          draft.filteredProducts = data;
        });
      } else {
        errorMessage(message);
      }
    } catch (error) {
      const message =
        error.response?.data?.message ?? "Failed to fetch retail products";
      errorMessage(message);
    } finally {
      setState((draft) => {
        draft.loading = false;
      });
    }
  };

  const applyFilters = () => {
    setState((draft) => {
      const { retailProducts, filters } = draft;
      let filtered = [...retailProducts];

      if (filters.status !== "") {
        filtered = filtered.filter(
          (item) => String(item.status) === String(filters.status)
        );
      }

      draft.filteredProducts = filtered;
      draft.appliedFilters = { ...filters };
      draft.hasChanges = false;
    });
  };

  const resetFilters = () => {
    setState((draft) => {
      draft.filters = { status: "" };
      draft.appliedFilters = { status: "" };
      draft.filteredProducts = draft.retailProducts;
      draft.hasChanges = false;
    });
  };

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setState((draft) => {
      draft.filters[name] = value;
      draft.hasChanges =
        JSON.stringify(draft.filters) !== JSON.stringify(draft.appliedFilters);
    });
  };

  React.useEffect(() => {
    if (id) getRetailProducts(id);
  }, [id]);

  const isFilterApplied = React.useMemo(() => {
    return Object.values(state.appliedFilters).some((v) => v !== "");
  }, [state.appliedFilters]);

  return {
    state,
    onChangeFilter,
    applyFilters,
    resetFilters,
    isFilterApplied,
  };
};
